import logitravelSearcherSkeletonStyles from "./styles/logitravel.js";
const searcherSkeletonThemes = {
    logitravel: logitravelSearcherSkeletonStyles
};
export default searcherSkeletonThemes;

//# sourceMappingURL=index.js.map